import {graphql} from 'react-relay'

export const query = graphql`
  query BuildPageQuery($buildLocator: String!, $skip: Boolean!) {
    build(buildLocator: $buildLocator) @skip(if: $skip) {
      pipelineRun {
        pipeline {
          id
        }
      }
      pipelineRunJob {
        pipelineRun {
          build {
            id
          }
          pipeline {
            id
          }
        }
      }
    }
  }
`
